import { useState, useEffect } from 'react'
import { Select } from 'antd'
import { getDataOptions } from '../helpers'
import withRepeater from './withRepeater'
import withDerivedData from './withDerivedData'
import { getNodeLabel, isValidNamespaceUrl } from 'Services/WeaverUtils'
{ Option } = Select

SequencedFormSelectInput = ({
  form
  formItem
  queries
  options
  config: { mode, showSearch } = {}
  derivedData
  nodeId
  save
  props...
}) ->

  {
    orientation
    relationName
  } = save

  [loading, setLoading] = useState(true)
  [disabled, setDisabled] = useState(false)

  { initting, options } = withDerivedData({
    queries,
    derivedData
  })

  useEffect( ->
    (->
      if orientation is 'IN'
        n = await new Weaver.Query().restrict(nodeId).selectIn(relationName).withRelations().first()
        setDisabled(n.relationsIn[relationName].nodes.length > 1)
      return if initting or !props.value
      isValInOptions = (val) ->
        options.find(({ value }) -> value is val)
      if mode is 'multiple'
        valid = (props.value or []).filter(isValInOptions)
        if !_.isEqual(valid, props.value) then props.onChange(valid)
      else
        if !isValInOptions(props.value) then props.onChange(undefined)
    )()
    undefined
  , [options])

  <Select
    mode={mode}
    disabled={disabled}
    loading={initting}
    showSearch={showSearch or true}
    optionFilterProp="children"
    placeholder={if isValidNamespaceUrl(formItem) then formItem else _.startCase(formItem)}
    filterOption={(input, option) ->
      { children: { props } } = option
      props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    { props... }
  >
    {options.sort((a, b) -> a.attributeValue.replace(/\D/g,'') - b.attributeValue.replace(/\D/g,''))
      .map((option) ->
        <Option
          disabled={option.disabled or false}
          key={option.value or option}
          value={option.value or option}
        >
          { option.label }
        </Option>
    )}
  </Select>

export default withRepeater(SequencedFormSelectInput, { selector: (value) -> value })
